import type { AxiosInstance } from 'axios';
import type { AuditEvent } from '../types/signing';

/**
 * Envelope audit-trail service.
 *
 * Backend endpoints (per `backend/contract-service/docs/api-endpoints.md`,
 * `AuditController` package, 2026-04-22 rework):
 *   - `GET /v1/envelopes/{id}/audit`      — JSON list
 *   - `GET /v1/envelopes/{id}/audit/pdf`  — A4 Certificate-of-Completion PDF
 *
 * The earlier `/audit-trail` alias was removed (line 2218 of the spec). The
 * audit-PDF endpoint renders a 4-column table (Timestamp / Action / Actor / IP)
 * via PDFBox on the backend, auto-paginates, and honours the latest
 * `ENVELOPE_REVISED` event as the trail slice boundary so the certificate
 * reflects the post-retrigger state.
 */
export function createAuditService(client: AxiosInstance) {
  return {
    getAuditEvents: (envelopeId: string) =>
      client
        .get<AuditEvent[]>(`/v1/envelopes/${envelopeId}/audit`)
        .then((r) => r.data),

    downloadAuditPdf: (envelopeId: string) =>
      client.get<Blob>(`/v1/envelopes/${envelopeId}/audit/pdf`, {
        responseType: 'blob',
      }),
  };
}
